<div class="quote-pdf-page app-aul-101-24">
  <app-policy-header></app-policy-header>
  <p style="margin-bottom: 0;text-align: center !important;font-size: 22px;">
    <b>COMMERCIAL PROPERTY QUOTE</b>
  </p>
  <p style="text-align: center !important;font-size: 22px;">
    <b>POLICY APPLICATION AND QUOTE SUMMARY</b>
  </p>
  <p style="font-size: 14px;">
    <b>
      This quote is valid until 11 : 59pm on the day before the proposed
      effective Inception date or 60 days after the date the quote was issued.
    </b>
  </p>
  <br />
   <table  style="width:100%; font-size: 16px;">
    <tbody>
      <tr>
         <td style="width: 100% !important;">
          <b>Named Insured:</b> <span><b>{{ quoteDetails?.nameInsured }}</b></span>
        </td>
      </tr>
    </tbody>
   </table>
    <table  style="width:100%; font-size: 14px;">
   <tbody>
      <tr> 
          <td style="width: 50% !important;">
          Primary Address:
          <span
            >{{ quoteDetails?.primaryAddress[0]?.streetNum }},
            {{ quoteDetails?.primaryAddress[0]?.streetName }},
            {{
              quoteDetails?.primaryAddress[0]?.unitNum
                ? quoteDetails?.primaryAddress[0]?.unitNum + ","
                : ""
            }}
            {{ quoteDetails?.primaryAddress[0]?.city }},
            {{ quoteDetails?.primaryAddress[0]?.county }},
            {{ quoteDetails?.primaryAddress[0]?.state }},
            {{ quoteDetails?.primaryAddress[0]?.zipcode }}</span
          >
        </td>
      </tr>
    </tbody>
   </table>
  <table  style="width:100%; font-size: 14px;">
    <tbody>
      
      <tr>
        <td style="width: 50% !important;">
          Quote Number: <span>{{ quoteDetails?.quoteNo }} - 0{{ quoteDetails?.versionNo }}</span>
        </td>
        <td style="width: 50% !important;">
          Date Quote Issued:<span>{{
            quoteDetails?.quoteDate | date : "MM/dd/yyyy"
          }}</span>
        </td>
      </tr>
    </tbody>
  </table>
  <br />
  <table style="width:100%; font-size: 14px;">
    <tbody>
      <tr>       
        <td style="width: 50% !important;">
          Proposed Policy Period: Inception Date:
          <span>{{ quoteDetails?.inceptionDate | date : "MM/dd/yyyy" }}</span>
        </td>
        <td style="width: 50% !important;">
          Expiry Date:
          <span>{{ quoteDetails?.expiryDate | date : "MM/dd/yyyy" }}</span>
        </td>
      </tr>
    </tbody>
  </table>
  <!-- <p style="font-size: 14px;">At 12:01 AM Standard Time at Covered Premises Address</p> -->
  <table  style="width:100%; font-size: 14px;">
    <tbody>
      <tr>
         <td style="width: 100% !important;">
          At 12:01 AM Standard Time at Covered Premises Address
        </td>
      </tr>
    </tbody>
   </table>
 
  <hr />
     <table  style="width:100%; font-size: 14px;">
    <tbody>
      <tr>
         <td style="width: 50% !important;">
          Producer Name: {{ quoteDetails?.agentAddress[0]?.producingAgentName }}
        </td>
      </tr>
      <tr>
         <td style="width: 50% !important;">
          Mailing Address:
          <span
            >{{ quoteDetails?.agentAddress[0]?.streetNum }},
            {{ quoteDetails?.agentAddress[0]?.streetName }},
            {{
              quoteDetails?.agentAddress[0]?.unitNum
                ? quoteDetails?.agentAddress[0]?.unitNum + ","
                : ""
            }}
            {{ quoteDetails?.agentAddress[0]?.city }},
            {{ quoteDetails?.agentAddress[0]?.county }},
            {{ quoteDetails?.agentAddress[0]?.state }},
            {{ quoteDetails?.agentAddress[0]?.zipcode }}</span
          >
        </td>
      </tr>
    </tbody>
   </table>
   <hr />
  <table style="width:100%; font-size: 14px;">
    <tbody>
      <tr>
        <td style="width: 50% !important;"><b>Coverage Part</b></td>
        <td style="width: 50%; text-align: left;">
          <span style="display: inline-block; width: 130px; text-align: right; white-space: nowrap; margin-right: auto;">
            <b>Premium</b>
          </span>
        </td>      
      </tr>
      <tr>
        <td style="width: 50% !important;">Commercial Property Coverage Part</td>
        <td style="width: 50% !important; text-align: left;">
          <span style="display: inline-block; width: 130px; text-align: right; font-variant-numeric: tabular-nums; font-feature-settings: 'tnum'; white-space: nowrap; margin-right: auto;">
            $
            {{
              quoteDetails?.commericalPropCovPart
                | currency : "USD" : "" : "1.2-2"
            }}
          </span>
        </td>
      </tr>
      @if(quoteDetails?.eqbdPremium !== 0){
      <tr>
        <td style="width: 50% !important;">Equipment Breakdown Part</td>
        <td style="width: 50% !important; text-align: left;">
          <span style="display: inline-block; width: 130px; text-align: right; font-variant-numeric: tabular-nums; font-feature-settings: 'tnum'; white-space: nowrap; margin-right: auto;">
            $ {{ quoteDetails?.eqbdPremium | currency : "USD" : "" : "1.2-2" }}
          </span>
        </td>
      </tr>
    }
      <tr>
        <td style="width: 50% !important;">Inspection Fee</td>
        <td style="width: 50% !important; text-align: left;">
          <span style="display: inline-block; width: 130px; text-align: right; font-variant-numeric: tabular-nums; font-feature-settings: 'tnum'; white-space: nowrap; margin-right: auto;">
            $ {{  quoteDetails?.inspectionFee | currency : "USD" : "" : "1.2-2" }}
          </span>
        </td>
      </tr>
            <tr
        *ngFor="let fee of quoteDetails?.qislFeeDetails"
      >
        <td style="width: 50%">
          {{ fee?.otherDescription || fee?.slFeeDescription }}
        </td>
        <td style="width: 50%; text-align: left;">
          <span style="display: inline-block; width: 130px; text-align: right; font-variant-numeric: tabular-nums; font-feature-settings: 'tnum'; white-space: nowrap; margin-right: auto;">
            $
            {{ fee?.feeAmount | currency : "USD" : "" : "1.2-2" }}
          </span>
        </td>
      </tr>
      <tr>
        <td style="width: 50% !important;"><b>Total Policy Premium</b></td>
        <td style="width: 50% !important; text-align: left;">
          <b>
            <span style="display: inline-block; width: 130px; text-align: right; font-variant-numeric: tabular-nums; font-feature-settings: 'tnum'; white-space: nowrap; margin-right: auto;">
              $
              {{              
                quoteDetails?.commericalPropCovPart +
                quoteDetails?.eqbdPremium+
                quoteDetails?.inspectionFee +
                surplusFeeTotal
                  | currency : "USD" : "" : "1.2-2"
              }}
            </span>
          </b>
        </td>
      </tr>
    </tbody>
  </table>
  <hr />
    <p style="font-size: 14px; margin-bottom: 0 !important;">
    Terrorism coverage can be purchased for an additional premium of ${{ quoteDetails?.triaPremium | currency : "USD" : "" : "1.2-2" }} <b><i>Plus applicaple Taxes & Fees.</i></b> Policyholder disclosure of Terrorism Insuarance Coverage is attached to this Quote.
  </p>
  <hr />
  <p style="font-size: 14px; margin-bottom: 0 !important;">
    The Total Policy Premium quoted was computed based on rates in effect at the
    time the quote was issued and based on the information provided by you and
    detailed within this quote. You warrant that all information is accurate and
    any changes to this information must be disclosed prior to binding and if
    not disclosed may affect the validity of your policy.
  </p>
  <br />
  <p style="font-size: 14px;">
    Subject to any minimum earned endorsements listed within the policy, 25% of
    the Policy Premium is fully earned as of the effective date of this policy
    and is not subject to return or refund.
  </p>
  <br />
  <p style="font-size: 14px; margin-bottom: 0 !important;">
    All Policy, Administration and/or Inspection Fees identified in this quote
    and/or identified on the Producer’s quotation jacket are fully earned as of
    the policy inception date and are not refundable.
  </p>
  <br />
  <p style="font-size: 14px; margin-bottom: 0 !important;word-spacing: 1px;">
    <b>
      SURPLUS LINES INSURERS’ POLICY RATES AND FORMS ARE NOT APPROVED BY ANY
      STATE REGULATORY AGENCY. PERSONS INSURED BY SURPLUS LINES INSURERS DO NOT
      HAVE THE PROTECTION OF ANY STATE GUARANTY ACT TO THE EXTENT OF ANY RIGHT
      OF RECOVERY FOR THE OBLIGATION OF AN INSOLVENT UNLICENSED INSURER
    </b>
  </p>
  <br />
  <p style="font-size: 14px;">
    The Producer named in this policy is responsible for calculating and
    remitting any and all surplus lines taxes and fees that may apply to this
    policy.
  </p>
  <br />
  <p style="font-size: 14px;">
    The issuance of this quote is facilitated by Alchemy Underwriting Limited
    (AUL) on behalf of Insurers identified within this quote and in accordance
    with the authorization granted to AUL and its affiliates. AUL is not an
    insurer and is not liable to indemnify the insured under the terms of this
    quote. Insurers may be subject to change at binding.
  </p>
</div>

<div class="quote-pdf-page app-aul-101-24">
  <p style="font-size: 19px;"><b>Security</b></p>
  <table style="width:100%; font-size: 14px;border: 1px solid black;border-collapse: collapse;">
    <thead>
      <tr>
        <th style=" border: 1px solid #000;padding: 0px 6px;text-align: left;background-color: #ccc;">Insurer</th>
        <th style=" border: 1px solid #000;padding: 0px 6px;text-align: left;background-color: #ccc;">Fortegra Specialty Insurance Company</th>
      </tr>
    </thead>
    <tbody style="border-width: 1px;">
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;"><b>Reference</b></td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;"><b>Participation</b></td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;"><b>B0600A2547583</b></td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;"><b>100%</b></td>
      </tr>
    </tbody>
  </table>
  <p style="font-size: 14px;">
    Carrier and/or carrier participations may be subject to change at binding.
  </p>
  <p style="font-size: 19px;"><b>The Applicant Warrants</b></p>
  <p style="font-size: 14px;">
    In requesting this quote to be formally bound, the information that you have
    provided to us will be used to validate your application, including the
    limits and coverage options, for compliance with the authority granted to
    Alchemy Underwriting Limited (AUL) as the coverholder for insurers.
  </p>
  <p style="font-size: 14px;">
    You warrant that all information provided by you in this application is
    accurate, complete and correct, and that no material facts have been
    omitted, misrepresented or misstated.
  </p>
  <br />
  <p style="font-size: 19px;"><b>SCHEDULE OF FORMS AND ENDORSEMENTS</b></p>
  <p style="font-size: 14px;">
    <b>The specific list of ISO Coverage Forms, ISO Causes of Loss Forms, and all other applicable forms and endorsements, will be determined by the coverage options, terms, and conditions agreed by Us</b>
  </p>
  <p style="font-size: 14px;">
    <b>The forms and endorsements listed in this Schedule do not represent a complete listing of all policy forms that may be issued by us. However, the following list of forms are applied to all policies:</b>
  </p>
  <table style="font-size: 12px;border-collapse: collapse;width: 100%;margin: 10px 0;">
    <thead>
      <tr>
        <th style=" border: 1px solid #000;padding: 0px 6px;text-align: left;background-color: #ccc;">Form Reference</th>
        <th style=" border: 1px solid #000;padding: 0px 6px;text-align: left;background-color: #ccc;">Form Name</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 000/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL Commercial Lines Policy Jacket</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 013/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL Amendatory State Endorsement</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 001/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Common Policy Declarations</td>
      </tr>

      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 002/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Commercial Property Supplemental Declarations</td>
      </tr>

      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 003/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Schedule of Forms and Endorsements</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;width: 25% !important;">ILP 001 01 04</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;width: 25% !important;">
          US Treasury Department's Office of Foreign Assets Control (OFAC)
        </td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 008/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Claims Reporting Information</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 009/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Complaints Notice</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">PRIV-0100 6/22</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Privacy Policy</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 006/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Policyholder Disclosure Notice of Terrorism (with TRIA option)</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 010/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Fraud Notice Multi-state</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 011/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL Inspection Notice</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">IL 00 17 11 98</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Common Policy Conditions</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">CP 00 90 07 88</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Commercial Property Conditions</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 014/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Minimum Earned Premium Endorsement</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">CP 02 99 06 07</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Cancellation Changes</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 018/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Roof Valuation</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 030/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Protective Safeguards</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 031/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Burglary Protective Safeguards</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 039/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Heat Maintenance Protective Safeguards</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 019/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Cosmetic Damage to Roof Surface And Covering Exclusion</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">CP 01 40 07 06</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Virus or Bacteria Exclusion</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">CP 10 75 12 20</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Cyber Incident Exclusion</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">IL 09 35 07 02</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Certain Computer Related Losses</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 022/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Virtual Currency Exclusion</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 029/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Prior Loss Exclusion</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 016/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">War and Terrorism Exclusion</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 032/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Biological or Chemical Materials Exclusion</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 027/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Asbestos Endorsement</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 026/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Radioactive Contamination</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 024/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Seepage and Pollution</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 025/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Land Water and Air</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 035/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">Solar Panel Systems</td>
      </tr>
      <tr>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">AUL 037/24</td>
        <td style="border: 1px solid #000;padding: 0px 6px;text-align: left;">MICROORGANISM Exclusion(ABSOLUTE)</td>
      </tr>
    </tbody>
  </table>
</div>
